var _radialGradient, _linearGradient, _linearGradient2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoroccoKeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 48,
    cy: 39.532,
    r: 51.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffec1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f0e500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#945515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a0700"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 59.197,
    y1: 71.397,
    x2: 44.043,
    y2: 14.843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae8722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e500"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 15.428,
    y1: 34.83,
    x2: 80.537,
    y2: 34.83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffed2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ffee4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffed2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9aa00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 44.316,
    fill: "#d82226"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.477,
    cy: 50.677,
    r: 33.698,
    fill: "#930002"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 32.591,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.067 47.815c4.709-5.355 2.493-12.925-6.555-22.896a28.55 28.55 0 0 0-30.744-6.186c-7.109 3.785-12.095 7.94-15.603 15.326-1.016 2.031-2.308 5.17.092 6.647.739.462 2.031.923 2.862 1.385l.646.277c8.309 4.616 3.324 10.156 8.586 14.587 7.848 6.278 16.434 8.402 26.22 6.186 6.278-1.385 9.786-3.97 12.833-9.602.923-2.031 1.293-3.693 1.662-5.724z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.764 41.26 7.478 4.247c1.385-2.677 3.693-5.724 7.017-9.325l-4.247-7.478c-4.801 2.77-8.217 6.924-10.248 12.556zm53.179 9.325 2.77-7.94c-3.231-9.694-8.217-15.603-14.864-17.726l-1.846 7.478c6.924 1.939 11.541 8.032 13.941 18.188zM56.679 35.167c-5.355-1.385-10.894-1.57-16.341-.462l-5.632-9.325c7.017-4.893 16.157-5.632 23.82-1.846 0-.092-.554 3.878-1.846 11.633z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.459 55.755c7.478-.831 19.757-1.57 36.93-2.123.462-9.048-2.862-13.387-10.063-12.833l2.77-5.355h-4.247l-4.432 9.14h6.093c3.416-.092 5.355 1.57 5.632 5.17v.462l-15.603.277c.277-.462.369-1.293.462-2.585v-7.017h-3.97v7.478c.092 1.2-.185 2.031-.923 2.308h-5.17c.462-.369.646-1.108.739-2.123v-7.017h-3.97V49.2c-.277 1.2-.831 1.846-1.846 1.846a3.31 3.31 0 0 1-2.308 0v-3.693c-.739-2.954-2.308-4.432-4.709-4.709H29.72c-2.4.277-3.97 1.477-4.709 3.508v4.893c.277 2.308 1.662 3.785 4.247 4.432 1.2.277 2.585.277 3.97 0 0 1.2-.831 2.123-2.585 2.585v3.047c3.324.646 5.262-1.108 5.816-5.355zM30.55 51.6c-1.57-.277-2.308-1.385-2.123-3.231.277-1.2.739-2.123 1.846-2.123 1.662 0 1.846.923 2.123 1.846V51.6H30.55zm15.234 5.355h3.231v3.508h-3.231zm-5.17-20.865h3.231v3.508h-3.231zM50.77 56.402h3.231v3.508H50.77z",
    fill: "#af642a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.259 54.924c7.478-.831 19.757-1.57 36.93-2.123.462-9.048-2.862-13.387-10.063-12.833l2.77-5.355h-4.247l-4.339 9.048h6.093c3.416-.092 5.355 1.57 5.632 5.17v.462l-15.603.277c.277-.462.369-1.293.462-2.585v-7.017h-3.97v7.478c.092 1.2-.185 2.031-.923 2.308h-5.17c.462-.369.646-1.108.739-2.123v-7.017H39.6v7.663c-.277 1.2-.831 1.846-1.846 1.846a3.31 3.31 0 0 1-2.308 0V46.43c-.739-2.954-2.308-4.432-4.709-4.709h-2.123c-2.4.277-3.97 1.477-4.709 3.508v4.893c.277 2.308 1.662 3.785 4.247 4.432 1.2.277 2.585.277 3.97 0 0 1.2-.831 2.123-2.585 2.585v3.047c3.231.646 5.17-1.108 5.724-5.262zm-5.816-4.247c-1.57-.277-2.308-1.385-2.123-3.231.277-1.2.739-2.123 1.846-2.123 1.662 0 1.846.923 2.123 1.846v3.508h-1.846zm15.141 5.355h3.231v3.508h-3.231zm-5.17-20.865h3.231v3.508h-3.231zM49.57 55.571h3.231v3.508H49.57z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoroccoKeno);
export default __webpack_public_path__ + "static/media/morocco_keno.d099e301a08dc3f11d1af83236503292.svg";
export { ForwardRef as ReactComponent };